import {useState, useEffect} from 'react';
import {useParams} from "react-router-dom"
import {Modal} from "./question/Modal"
import {niveaux, sur_themes} from "./config/Config"
import {BugConnexion} from "./config/BugConnexion"
import {pluriel} from "./Fonctions"
import "./Notions.css"

export function Notions ({auth}) {

  const params = useParams()
  const [notions, setNotions] = useState({})
  const [selection, setSelection] = useState({
    notion:[],
    etoile:'0',
    nb_question:'3',
    niveau:params.niveau,
  })

  document.title = 'Notions ' + params.niveau

  const [show_activite, setShow_activite] = useState(false)
  const [bugConnexion, setBugConnexion] = useState(false)

  const current_niveau = niveaux.filter(e => e.slug === params.niveau)[0]
  const title_page = current_niveau.h1
  const styleRange = {width:"80%"}

  useEffect(()=>{
    /*console.log({
        action:'recup_notions',
        niveau:params.niveau,
      })*/
    fetch("https://maths-au-quotidien.fr/react-automaths/api-config.php", {
      method: 'POST',
      body: JSON.stringify({
        action:'recup_notions',
        niveau:params.niveau,
      })
    })
    .then(response => response.json())
    .then(data => {
      //console.log(data)
      if(auth.nom !== 'COLONVAL') {delete data.essai}
      setNotions(data)
    })
    .catch(err => {
        setBugConnexion(true)
        console.log(err)
      })
    }
  , [])

  const handleClick = (e) => {

    if(e.target.attributes.name.nodeValue === 'notion'){
      let sel = selection.notion
      if(!selection.notion.includes(e.target.title)) {
        if(selection.notion.includes(e.target.title.split('/')[0])){
          sel = [...selection.notion.filter(elt => elt !== e.target.title.split('/')[0]), e.target.title]
        } else {
          if(e.target.className !== 'sousnotion'){
            sel = sel.filter(elt => !elt.includes(e.target.title.split('/')[0]))
          }
          sel = [...sel, e.target.title]
        }
      } else {
        sel = selection.notion.filter(elt => elt !== e.target.title)
      }
      setSelection({...selection, notion:sel})
    } else {
      setSelection({...selection, [e.target.attributes.name.nodeValue]:e.target.title})
    }
  }

  let class_notion = 'sideBar'
  if(params.niveau === '3e' || params.niveau === '6e') {class_notion += ' end_3e'}
  /*if(params.niveau === 'voie-technologique') {class_notion += ' end_techno'}
  if(params.niveau === 'tronc-com-1reG') {class_notion += ' end_tronc_com'}*/
  if(params.niveau === '2de_pro' || params.niveau === '1re_pro') {class_notion += ' end_2de_pro'}
  if(params.niveau === 'term-G' || params.niveau === 'maths-complementaires') {class_notion += ' color_first'}
  ////////////////////////////////////////////////

  let pos_themes = []
  sur_themes.map((e, k) => e.niveau === params.niveau && pos_themes.push(sur_themes[k].pos))

  const current_theme = (k) => {
    let theme = {}
    sur_themes.forEach(e => {
      if(e.pos === k && e.niveau === params.niveau) {theme = e} 
    })
    return theme
  }
  ////////////////////////////////////////////////
  //console.log(auth)
  //console.log(selection) 
  return (
    <div>
    	<h1 style={{color:"#314159"}}><span style={{color:"#C8E162", textShadow:"initial", fontWeight:"bold", fontStyle:'italic'}} >Automaths</span> - {/*{title_college.includes(params.niveau) ? title_college_h1[title_college.indexOf(params.niveau)] : title_lycee_h1[slug_lycee.indexOf(params.niveau)]}*/} {title_page}</h1>

      {bugConnexion && <BugConnexion/>}  

      <div className={class_notion} style={{backgroundColor:current_niveau.color}}>
        <h1>Notions</h1>
        
        <ul>
          {Object.keys(notions).map((e, k) =>
            pos_themes.includes(k) ?  <><span key={'notion1'+k} style={{display:'block', marginTop:'10px', color:current_theme(k).color, borderBottom:'2px solid '+current_theme(k).color, borderTop:'0px solid '+current_theme(k).color}}><li className='sur_theme'>{current_theme(k).theme}</li></span>
            <span key={k} className={selection.notion.some(elt=>elt.includes(e)) ? 'active' : ''}>
                        <li title={e} name="notion" onClick={handleClick} className={selection.notion.includes(e) ? 'selected' : ''} >{e}</li>
                        {notions[e].length ?
                          <> {notions[e].map((elt, k2) => <li key={'sousnotion1'+k2} title={e+'/'+elt} name="notion" onClick={handleClick} className={selection.notion.includes(e+'/'+elt) ? 'sousnotion selected' : 'sousnotion'}>{elt}</li>)}
                          </>
                        : ''}
                      </span></>
            : <span key={k} className={selection.notion.some(elt=>elt.includes(e)) ? 'active' : ''}>
                        <li title={e} name="notion" onClick={handleClick} className={selection.notion.includes(e) ? 'selected' : ''} >{e}</li>
                        {notions[e].length ?
                          <> {notions[e].map((elt, k2) => <li key={'sousnotion2'+k2} title={e+'/'+elt} name="notion" onClick={handleClick} className={selection.notion.includes(e+'/'+elt) ? 'sousnotion selected' : 'sousnotion'}>{elt}</li>)}
                          </>
                        :''}
                      </span>
            )}
        </ul>
      </div>
      <div className="intro">
        <h2>Choix des notions :</h2>
        Veuillez choisir une ou plusieurs notions dans le menu de gauche.
        <br/>

        {/*=======================================*/}
        {
          params.niveau !== "PPO" ? 
          <>
        <h2>Choix du niveau (facultatif) :</h2>
        Chaque question comporte un niveau. Vous avez la possibilité de choisir un niveau en cliquant sur l'un des niveaux suivants.
        <br/>
        Si vous ne choisissez pas de niveau, les questions seront "multi-niveaux".
        <br/>
        {
          ['⭐', '⭐⭐', '⭐⭐⭐'].map((e,k)=>
            <div key={k} title={k+1} name='etoile' className={'etoile'+(selection.etoile === k+1 ? ' active' : '')} 
              onClick={()=> selection.etoile === k+1 ? 
                      setSelection({...selection, etoile:'0'})
                    : setSelection({...selection, etoile:k+1}) }>
                {e} Niveau&nbsp;{k+1}
            </div>)
        }
          </> : ''
        }
        <br/>


        {/*=======================================*/}
        <h2>Choix du nombre de questions :</h2>
        <input type="range" name="nb_question" style={styleRange} min="1" max="10" defaultValue={3} onChange={(e)=>setSelection({...selection, nb_question:e.target.value})}/> <span className="btn_param active">{selection.nb_question} question{pluriel(selection.nb_question)}</span>
        <br/>
        {/*['3', '5', '10'].map((e,k)=><div key={k} title={e} name='nb_question' className={'etoile'+(selection.nb_question === e ? ' active' : '')} onClick={handleClick}>{e} questions</div>)*/}


        {/*=======================================*/}
        <div className="selection" onClick={()=>setSelection({...selection, notion:[]})}>
          <div className="suppr" title="Effacer"  ></div>
          {selection.notion.sort().map((e, k) => 
              <span key={k} title={e}>{e.split('/')[e.includes('/') ? 1 : 0]}<br/></span>
            )}
        </div>


        {selection.notion.length ? <button name="listeChoix" className="btn center" onClick={()=>setShow_activite(true)}> Valider </button> : ''}
      </div>  

      {show_activite ? 
        <Modal auth={{...auth, notion:selection.notion, nb_question:selection.nb_question, etoile:selection.etoile, activite:selection.notion.join('__'), niveau:selection.niveau, action:'rech_question'}} setShow_activite={setShow_activite} />
          : ''}
    </div>
  );
}